import { render } from "./EmployeeDeniedRequests.vue?vue&type=template&id=00085ab2"
import script from "./EmployeeDeniedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__